import { createIcon } from "@chakra-ui/react";

/**
 * The AngularJS calendar's broadcast glyph - public/admin/images/icons/broadcast.svg,
 * inlined so it can inherit `currentColor` and keep the pulse the legacy stylesheet gives
 * it (`.broadcast-icon g > path { animation: broadcastIcon 1s infinite backwards }`,
 * custom.css) with the same 0/150/300ms stagger from the dot outwards.
 */
const wavePulse = (begin: string) => (
  <>
    <animate attributeName="opacity" begin={begin} dur="1s" repeatCount="indefinite" values="0;1" />
    <animateTransform
      attributeName="transform"
      begin={begin}
      dur="1s"
      repeatCount="indefinite"
      type="translate"
      values="-2 0;0 0"
    />
  </>
);

const AnimatedBroadcastWavesIcon = createIcon({
  displayName: "AnimatedBroadcastWavesIcon",
  viewBox: "0 0 16 16",
  path: (
    <>
      <path
        d="M9.17857 14.098L9.50145 13.7511C10.9548 12.1894 11.7552 10.147 11.7552 7.99997C11.7552 5.85294 10.9548 3.81055 9.50142 2.24888L9.17854 1.90196L11.2595 0L11.5765 0.34176C13.509 2.42466 14.5732 5.1444 14.5732 8C14.5732 10.8556 13.509 13.5753 11.5765 15.6582L11.2595 16L9.17857 14.098Z"
        fill="currentColor"
      >
        {wavePulse("0.3s")}
      </path>
      <path
        d="M5.70848 10.9285L6.03709 10.5814C7.38356 9.15908 7.38359 6.84482 6.03709 5.42245L5.70848 5.07537L7.79101 3.17187L8.10819 3.51072C9.24187 4.72196 9.86621 6.31694 9.86621 8.00192C9.86621 9.68689 9.24187 11.2819 8.10819 12.4931L7.79101 12.832L5.70848 10.9285Z"
        fill="currentColor"
      >
        {wavePulse("0.15s")}
      </path>
      <path
        d="M1.42726 7.99975C1.42726 6.96386 2.27002 6.12109 3.30591 6.12109C4.34181 6.12109 5.18457 6.96386 5.18457 7.99975C5.18457 9.03564 4.34181 9.87841 3.30591 9.87841C2.27002 9.87841 1.42726 9.03564 1.42726 7.99975Z"
        fill="currentColor"
      >
        {wavePulse("0s")}
      </path>
    </>
  ),
});

export default AnimatedBroadcastWavesIcon;
